"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirePostalCode = exports.validateSignupFields = exports.isValidCanadianPostalCode = exports.isValidUsPostalCode = exports.BITHDATE_ERRORS = exports.REQUIRED_ERROR = exports.INVALID_PHONE_ERROR = exports.INVALID_DATE_ERROR = exports.MAXIMUM_AGE_ERROR = exports.MINIMUM_AGE_ERROR = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
const constants_1 = require("core/constants");
const useAmpli_1 = require("src/hooks/useAmpli");
exports.MINIMUM_AGE_ERROR = 'Terms violated.';
exports.MAXIMUM_AGE_ERROR = 'Date must be valid.';
exports.INVALID_DATE_ERROR = 'Date must be valid.';
exports.INVALID_PHONE_ERROR = 'Invalid phone number';
exports.REQUIRED_ERROR = 'This field is required';
exports.BITHDATE_ERRORS = {
    min: exports.MINIMUM_AGE_ERROR,
    limit: exports.MAXIMUM_AGE_ERROR,
    valid: exports.INVALID_DATE_ERROR,
};
const isValidUsPostalCode = (postalCode) => {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(postalCode);
};
exports.isValidUsPostalCode = isValidUsPostalCode;
const isValidCanadianPostalCode = (postalCode) => {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postalCode);
};
exports.isValidCanadianPostalCode = isValidCanadianPostalCode;
const validatePostalCode = (postalCode, country) => {
    if (!postalCode) {
        return false;
    }
    if (country === 'United States') {
        return (0, exports.isValidUsPostalCode)(postalCode);
    }
    else if (country === 'Canada') {
        return (0, exports.isValidCanadianPostalCode)(postalCode);
    }
    return (0, exports.isValidUsPostalCode)(postalCode) || (0, exports.isValidCanadianPostalCode)(postalCode);
};
const validateSignupFields = (data, fields) => {
    // if fields is not provided, validate all fields
    return Object.keys(data).reduce((acc, key) => {
        if (!fields || fields.includes(key)) {
            if (typeof data[key] === undefined || data[key] === null || data[key] === '') {
                acc[key] = exports.REQUIRED_ERROR;
            }
            else if (key === 'rosterBirthdate') {
                // only check for a valid date
                const birthdateError = (0, snap_ui_1.getBirthdateErrors)(data[key], constants_1.MAXIMUM_ACCOUNT_AGE, 0, exports.BITHDATE_ERRORS) || undefined;
                if (birthdateError) {
                    acc[key] = birthdateError;
                }
            }
            else if (key === 'birthdate') {
                // check for valid date and minimum age
                const birthdateError = (0, snap_ui_1.getBirthdateErrors)(data[key], constants_1.MAXIMUM_ACCOUNT_AGE, constants_1.MINIMUM_ACCOUNT_AGE, exports.BITHDATE_ERRORS);
                if (birthdateError === exports.MINIMUM_AGE_ERROR) {
                    // min age error should not show up on the field but a reserved key
                    acc['termsViolated'] = useAmpli_1.AmplitudeAccountBlockedReasons.AGE;
                }
                else if (birthdateError) {
                    // all other errors should show up on the field
                    acc[key] = birthdateError;
                }
            }
            else if (key === 'phone' && !(0, snap_ui_1.isValidPhoneNumber)(data[key])) {
                acc[key] = exports.INVALID_PHONE_ERROR;
            }
            else if (key === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data[key])) {
                acc[key] = 'Invalid email address';
            }
            else if (key === 'password' && data[key].length < 8) {
                acc[key] = 'Password must include at least 8 characters.';
            }
            else if (key === 'postalCode' && !validatePostalCode(data[key], data['country'])) {
                acc[key] = 'Please enter a valid postal code';
            }
            else if (key === 'termsAndConditionsAccepted' && !data[key] && fields?.includes(key)) {
                acc[key] = 'You must agree to the terms and conditions';
            }
        }
        return acc;
    }, {});
};
exports.validateSignupFields = validateSignupFields;
const requirePostalCode = (countryCode) => {
    return ['United States', 'Canada'].includes(countryCode);
};
exports.requirePostalCode = requirePostalCode;
